/**
 * Cloud REST API (partner tokens) — eligibility from GET public/v1/supportedFeatures/{sessionId}.
 * Requires FEATURE_IDS.CLOUD_REST_API enabled and details.cloudRESTSupport === "1".
 */

import { FEATURE_IDS, isFeatureEnabled } from './supportedFeatures';

/**
 * @param {object|null|undefined} details - API `details` object
 * @returns {boolean}
 */
export function computeCloudRestApiEnabled(details) {
  if (!details || typeof details !== 'object') return false;
  const isCloudRestSupportOn = String(details.cloudRESTSupport) === '1';
  const isCloudRestPortalFeatureEnabled = isFeatureEnabled(FEATURE_IDS.CLOUD_REST_API);
  return Boolean(isCloudRestPortalFeatureEnabled && isCloudRestSupportOn);
}
